import { fromJS } from 'immutable';
import {
  START_SEARCH,
  STOP_SEARCH,
  SET_SEARCHER_CAROUSEL_DATE,
  UPDATE_SEARCHER_PARAMS,
  UPDATE_REQUEST_ID,
  SET_SEARCHER_DATE,
  SET_KIDS,
  SEARCHER_STATE,
  TOGGLE_INSTANT_CONFIRM,
  SET_FILTERS,
  CLEAR_SEARCHER_FILTERS,
  SET_SEARCHER_FETCHING,
  SET_DEPARTURE,
  SET_DEFAULT_FILTERS,
  OPEN_FILTERS_LIST,
} from '../constants/searcher';

const initialState = fromJS({
  state: SEARCHER_STATE.EMPTY,
});

export default function searcherReducer(state = initialState, action) {
  switch (action.type) {
    case START_SEARCH:
      return state.merge(
        fromJS({
          state: SEARCHER_STATE.FETCHING,
          lastUpdated: null,
        }),
      );
    case STOP_SEARCH:
      return state.merge(
        fromJS({
          state: SEARCHER_STATE.COMPLETED,
          lastUpdated: Date.now(),
        }),
      );
    case SET_SEARCHER_FETCHING: {
      const { payload } = action;
      return state.set(
        'state',
        payload ? SEARCHER_STATE.FETCHING : SEARCHER_STATE.COMPLETED,
      );
    }
    case UPDATE_SEARCHER_PARAMS:
      return state.merge(fromJS(action.payload));
    case UPDATE_REQUEST_ID:
      return state.set('requestId', action.payload);
    case SET_SEARCHER_DATE:
      return state.set('startDate', action.payload);
    case SET_SEARCHER_CAROUSEL_DATE:
      return state.set('carouselDate', action.payload.date);
    case SET_KIDS:
      return state.set('kidsAges', fromJS(action.payload));
    case SET_DEPARTURE: {
      const { payload } = action;
      return state.merge(
        fromJS({
          departure: payload,
          from: {
            city: payload,
            country: payload,
          },
        }),
      );
    }
    case TOGGLE_INSTANT_CONFIRM:
      return state.set('instantConfirm', !state.get('instantConfirm'));
    case SET_DEFAULT_FILTERS:
      return state.set('setDefaultFilters', fromJS(action.payload));
    case SET_FILTERS: {
      const { payload } = action;
      const { instantConfirm, freeCancel, confirmability, ...filters } =
        payload;

      return state.merge(
        fromJS({
          instantConfirm,
          freeCancel,
          confirmability,
          filters,
        }),
      );
    }
    case CLEAR_SEARCHER_FILTERS:
      return state.merge(
        fromJS({
          operatorsFilter: {},
          filters: {},
          instantConfirm: false,
          freeCancel: false,
          confirmability: 3,
        }),
      );
    case OPEN_FILTERS_LIST:
      return state.set('openFiltersList', action.payload);
    default:
      return state;
  }
}
